import { mapState } from 'pinia';
import stores from 'store/modules';

export default {
    data: () => ({
        inboxIds: [],
    }),

    computed: {
        ...mapState(stores.Inboxes, ['inboxes', 'inboxesArray']),
        ...mapState(stores.User, ['user', 'loadingMain']),
        ...mapState(stores.Broadcasts, ['broadcasts']),
    },

    watch: {
        'inboxesArray.length'(length) {
            if (!length) return;

            this.initInboxesEcho();
        },

        'user.id'(id) {
            this.initUserInboxEcho();
        },

        isLoadingEcho(status) {
            if (status) return;

            this.initUserInboxEcho();
            this.initInboxesEcho();
        },
    },

    methods: {
        initInboxesEcho() {
            this.resetInboxesEcho();

            this.inboxesArray.forEach((inbox) => {
                this.echoInboxJoin(inbox.id);
            });
        },

        resetInboxesEcho() {
            this.inboxesArray.forEach((inbox) => {
                this.echoInboxLeave(inbox.id);
            });
        },

        echoInboxLeave(id) {
            if (!this.$echo) return;

            this.$echo
                .private(`inbox.${id}`)
                .stopListening('.message.popper')
                .stopListening('.inbox.calling');

            this.$echo
                .join(`inbox.${id}`)
                .stopListening('.inbox.deleted')
                .stopListening('.message.popper')
                .stopListening('.conversation.read')
                .stopListening('.conversation.unread')
                .stopListening('.inbox.calling');

            this.$echo.leave(`inbox.${id}`);
        },

        initUserInboxEcho() {
            if (!this.user?.id) return;
            if (!this.$echo) return;

            this.resetUserInboxEcho();

            this.$echo
                .private(`user.${this.user.id}`)
                .listen('.inbox.created', this.echoInboxCreated)
                .listen('.inbox.updated', this.echoInboxUpdated)
                .listen('.inbox.deleted', this.echoInboxDeleted)
                .listen('.conversation.read', this.echoConversationRead)
                .listen('.conversation.unread', this.echoConversationUnread)
                .listen('.inbox.member.added', this.echoInboxCreated)
                .listen('.inbox.member.removed', this.echoInboxDeleted)
                .listen('.organization.calling', this.echoOrganizationCalling);
        },

        resetUserInboxEcho() {
            if (!this.user?.id) return;
            if (!this.$echo) return;

            this.$echo
                .private(`user.${this.user.id}`)
                .stopListening('.inbox.created')
                .stopListening('.inbox.updated')
                .stopListening('.inbox.deleted')
                .stopListening('.conversation.read')
                .stopListening('.conversation.unread')
                .stopListening('.inbox.member.added')
                .stopListening('.inbox.member.removed')
                .stopListening('.organization.calling');
        },

        echoInboxJoin(id) {
            if (!this.$echo) return;

            this.$echo
                .private(`inbox.${id}`)
                .listen('.message.popper', this.echoMessagePopper)
                .listen('.inbox.calling', this.echoInboxCalling);

            this.$echo
                .join(`inbox.${id}`)
                .listen('.inbox.deleted', this.echoInboxDeleted)
                .listen('.message.popper', this.echoMessagePopper)
                .listen('.conversation.read', this.echoConversationRead)
                .listen('.conversation.unread', this.echoConversationUnread)
                .listen('.inbox.calling', this.echoInboxCalling);
        },

        async echoOrganizationCalling(data) {
            this.$store.dispatch('organizationUpdate', {
                organization_call: data.organization_call,
            });
        },

        async echoInboxCalling(data) {
            const inbox = this.inboxes[data.team_id].clone();

            if (inbox) {
                inbox.number.use_organization_call_settings =
                    data.number.use_organization_call_settings;
                inbox.number.voice = data.number.voice;
                inbox.number.voice_outbound = data.number.voice_outbound;

                this.$store.dispatch('inboxUpdated', inbox);
            }
        },

        async echoInboxMemberRemoved(data) {
            await this.$store.dispatch('getUserMe');

            const mainInboxOwner = this.inboxesArray.find(
                (inbox) => inbox.is_main && inbox.owner.id === this.user.id
            );

            if (mainInboxOwner) {
                const inbox = await this.$store.dispatch('updateUsersTeam', mainInboxOwner.id);
                await this.$store.dispatch('setUnreadCount', inbox);
            }
        },

        async echoInboxMemberAdd(data) {
            await this.$store.dispatch('getUserMe');
        },

        echoInboxCreated(e) {
            this.$store.dispatch('showToast', {
                type: 'info',
                message: `You have been added to the ${e.name} inbox.`,
            });

            if (e.number) {
                this.$store.dispatch('inboxCreated', e);
            }

            this.echoInboxJoin(e.id);
        },

        echoInboxUpdated(e) {
            const oldInbox = this.inboxes[e.id];

            if (oldInbox && oldInbox.name !== e.name) {
                this.$store.dispatch('showToast', {
                    type: 'info',
                    message: `The ${oldInbox.name} inbox has been renamed to ${e.name}.`,
                });
            }

            this.$store.dispatch('inboxUpdated', e);
        },

        async echoInboxDeleted(e) {
            if (window.location.pathname.startsWith('/conversations')) {
                window.location = '/';
            } else {
                this.$store.dispatch('showToast', {
                    type: 'info',
                    message: `You have been removed from the ${e.name} inbox.`,
                });

                if (
                    !window.location.pathname.includes(
                        `settings/organization/inboxes/all-inboxes/${e.id}/settings`
                    )
                ) {
                    await this.$store.dispatch('getUserMe');
                    this.$store.dispatch('inboxDeleted', e.id);
                }

                this.echoInboxLeave(e.id);
            }
        },
    },
};
